import React from "react";
import { createBrowserRouter } from "react-router-dom";

import { createRouterObservers } from "mystique/lib";

import { routes } from "./routes";

export const router = createBrowserRouter([routes()]);

createRouterObservers(router);
